import { tsParticles } from "@tsparticles/engine";
import { loadSlim } from "@tsparticles/slim";

/**
 * tsParticles Setup
 * https://github.com/tsparticles/tsparticles
 */

(async () => {
  // Nur auf der Startseite laden
  if (!document.body.classList.contains('home')) {
    return;
  }

  await loadSlim(tsParticles);

  await tsParticles.load({
    id: "tsparticles",
    options: {
      fullScreen: {
        enable: true,
        zIndex: 0
      },
      detectRetina: true,
      fpsLimit: 120,
      interactivity: {
        detectsOn: "window",
        events: {
          onClick: {
            enable: false,
            mode: "repulse"
          },
          onHover: {
            enable: true,
            mode: "repulse"
          }
        },
        modes: {
          bubble: {
            distance: 250,
            duration: 2,
            opacity: 0,
            size: 7
          },
          repulse: {
            distance: 150,
            duration: 0.4
          },
          push: {
            quantity: 4
          }
        }
      },
      particles: {
        paint: {
          fill: {
            enable: true,
            color: {
              value: "#DD7D4A"
            }
          }
        },
        move: {
          direction: "none",
          enable: true,
          outModes: {
            default: "out"
          },
          random: false,
          speed: { min: 0.1, max: 2 },
          straight: false
        },
        number: {
          density: {
            enable: true,
            width: 1920,
            height: 1080
          },
          value: 160
        },
        opacity: {
          value: { min: 0.1, max: 1 },
          animation: {
            enable: true,
            speed: 1,
            sync: false,
            startValue: "random"
          }
        },
        shape: {
          type: "circle"
        },
        size: {
          value: { min: 1, max: 3 }
        }
      },
      pauseOnBlur: true,
      pauseOnOutsideViewport: true
    }
  });
})();